/**
 * LA COQUE DES PAGES — refonte « bonnes affaires » du 2026-09-14.
 *
 * Toutes les pages hors vitrine ont la même structure : l'en-tête du site, un
 * bandeau court (un titre, une ligne), puis le contenu dans une largeur de
 * lecture. Le pied de page est monté une seule fois par App.js.
 *
 * Avant : chaque page posait sa propre marge haute, son propre titre géant, et
 * trois pages légales dessinaient même leur propre barre de navigation.
 *
 *   largeur  'etroite' (lecture, formulaire) · 'normale' · 'large' (tableaux)
 */
import React from 'react';
import Navbar from './Navbar';
import './Page.css';

export default function Page({ titre, chapeau, avant, children, largeur = 'normale', className = '' }) {
  return (
    <>
      <Navbar />
      <main className={`zk-page zk-page-${largeur} ${className}`.trim()}>
        {avant}
        {(titre || chapeau) && (
          <header className="zk-page-tete">
            {titre && <h1>{titre}</h1>}
            {chapeau && <p>{chapeau}</p>}
          </header>
        )}
        {children}
      </main>
    </>
  );
}
